<template lang="pug">
.py-5.bg-light
  .container
    h2.text-center TouchScreen Size
    .touchscreen_size.pt-4
      a(
        style="cursor: pointer",
        v-for="(touchScreenSize, index) in touchScreenSizeList",
        @click="toTouchSize(touchScreenSize.id)"
      )
        img(:src="touchScreenSize.photo.image", style="margin-right: 4px")
</template>

<script>
import { getTouchScreenSizeList } from "@/api/touch_screen";

export default {
  name: "TouchScreenSize",
  data() {
    return {
      touchScreenSizeList: [],
    };
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getTouchScreenSizeList();
    },
    getTouchScreenSizeList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getTouchScreenSizeList(temp).then((response) => {
        this.touchScreenSizeList = response.data;
      });
    },
    toTouchSize(touchId) {
      this.$router.push({
        name: "TouchSize",
        params: {
          id: touchId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/touch_screen_size";
</style>
